// 环境类型
export enum Environment {
  // 开发环境
  DEVELOPMENT = "development",
  // 生产环境
  PRODUCTION = "production",
  // 测试环境
  TEST = "test",
}

// 前端项目
export enum FrontProject {
  // B端 - 企业端
  ENT = "ent",
  // 门户
  PORTAL = "portal",
  // C端 - 用户端
  CUSTOMER_SYSTEM = "customer_system",
  // SSO端
  SSO = "sso",
}

// 各个环境下每个端的跳转地址
export const SSO_REDIRECT_URL = {
  // 开发环境配置
  [Environment.DEVELOPMENT]: {
    // 企业端
    [FrontProject.ENT]: "http://localhost:9002",
    // 门户
    [FrontProject.PORTAL]: "http://localhost:9003",
    // 用户端
    [FrontProject.CUSTOMER_SYSTEM]: "http://localhost:9001",
    // SSO端
    [FrontProject.SSO]: "http://localhost:9000",
  },

  // 生产环境配置
  [Environment.PRODUCTION]: {
    // 企业端
    [FrontProject.ENT]: "https://ent.trthsz.com",
    // 门户
    [FrontProject.PORTAL]: "https://portal.trthsz.com",
    // 用户端
    [FrontProject.CUSTOMER_SYSTEM]: "https://eng.trthsz.com",
    // SSO端
    [FrontProject.SSO]: "https://common.trthsz.com",
  },

  // 测试环境配置
  [Environment.TEST]: {
    // 企业端
    [FrontProject.ENT]: "http://dev.ent.trthsz.com",
    // 门户
    [FrontProject.PORTAL]: "http://dev.portal.trthsz.com",
    // 用户端
    [FrontProject.CUSTOMER_SYSTEM]: "https://dev.eng.trthsz.com",
    // SSO端
    [FrontProject.SSO]: "http://dev.common.trthsz.com",
  },
};
